import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const ADMIN_WA = "6285811126712";
export const STORE_ADDRESS = "Jl. Parameter Utara, Kosambi, Rawa Burung, Tangerang";

export const formatRp = (n) => "Rp " + Math.round(Number(n) || 0).toLocaleString("id-ID");

export const formatDate = (iso, withTime = true) => {
  if (!iso) return "-";
  const d = new Date(iso);
  const opts = { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Asia/Jakarta" };
  if (withTime) Object.assign(opts, { hour: "2-digit", minute: "2-digit" });
  return d.toLocaleString("id-ID", opts);
};

export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u || "/images/yarn1.jpg");

export const normalizeWa = (p) => {
  let d = String(p || "").replace(/\D/g, "");
  if (d.startsWith("0")) d = "62" + d.slice(1);
  else if (d.startsWith("8")) d = "62" + d;
  return d;
};

export const waLink = (text, phone = ADMIN_WA) => `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;

export const errMsg = (e, fallback = "Terjadi kesalahan") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
};

export const CATEGORY_LABEL = { handmade: "Produk Handmade", bahan: "Alat & Bahan" };

export const STATUS_META = {
  pending: { label: "Pending", cls: "bg-amber-50 text-amber-800" },
  paid: { label: "Paid", cls: "bg-blue-50 text-blue-800" },
  packed: { label: "Packed", cls: "bg-stone-100 text-stone-700" },
  shipped: { label: "Shipped", cls: "bg-orange-50 text-orange-800" },
  completed: { label: "Completed", cls: "bg-green-50 text-green-800" },
  expired: { label: "Kedaluwarsa", cls: "bg-red-50 text-red-800" },
  cancelled: { label: "Dibatalkan", cls: "bg-red-50 text-red-800" },
};
